<div
  cdkDrag
  class="absolute bottom-5 left-1/2 z-[9999] flex h-14 -translate-x-1/2 transform items-center justify-between rounded-lg bg-bo-black/70 px-2 backdrop-blur-lg"
  cdkDragBoundary=".drag-boundary"
>
  <div class="flex h-full justify-center gap-5 p-2">
    <svg-icon
      class="cursor-move self-center fill-white/20"
      src="icons/grip.svg"
      [svgStyle]="{ 'height.px': 20 }"
    />
    @if (!appService.trackingMode()) {
      @if (!appService.demoMode()) {
        <svg-icon
          class="self-center fill-orange-500"
          src="icons/camera.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="appService.switchCamera()"
          data-e2e="button-uploadVideo"
        />
        <svg-icon
          class="self-center fill-yellow-500"
          src="fa-icons/upload.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="uploader.click()"
          data-e2e="button-uploadVideo"
        />
      } @else {
        <svg-icon
          class="self-center fill-bo-red"
          src="fa-icons/folder-xmark.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="removeDemoMovie()"
        />
      }
    }
    <input hidden type="file" #uploader (change)="selectDemoMovie($event)" />
    <input
      hidden
      type="file"
      #mltracking
      (change)="selectTracking($event)"
      webkitdirectory
      mozdirectory
    />

    @if (!appService.trackingMode()) {
      <svg-icon
        class="self-center fill-green-600"
        [ngClass]="{ 'fill-green-800': appService.demoMode() }"
        src="fa-icons/rocket-launch.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="appService.demoMode.set(!appService.demoMode())"
        data-e2e="button-sandbox"
      />
    }
    @if (appService.demoMode()) {
      @if (!appService.trackingMode()) {
        <svg-icon
          class="self-center fill-green-600"
          src="fa-icons/rotate-right.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="appService.replayVideo.emit()"
        />
      }
      @if (!appService.trackingMode()) {
        <svg-icon
          class="self-center fill-green-600"
          src="fa-icons/backward.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="appService.fastBackward.emit()"
        />
      }
      <svg-icon
        class="self-center fill-green-600"
        src="fa-icons/pause.svg"
        [svgStyle]="{ 'height.px': 20 }"
        (click)="appService.pauseVideo.emit()"
      />
      @if (!appService.trackingMode()) {
        <svg-icon
          class="self-center fill-green-600"
          src="fa-icons/forward.svg"
          [svgStyle]="{ 'height.px': 20 }"
          (click)="appService.fastForward.emit()"
        />
      }
    }
    <svg-icon
      class="self-center fill-blue-600"
      [ngClass]="{ 'fill-blue-800': appService.showConsole() }"
      src="fa-icons/square-terminal.svg"
      [svgStyle]="{ 'height.px': 20 }"
      (click)="appService.showConsole.set(!appService.showConsole())"
    />
    <svg-icon
      class="mr-2 self-center fill-purple-500"
      [ngClass]="{ 'fill-purple-700': appService.debugMode() }"
      src="fa-icons/bug.svg"
      [svgStyle]="{ 'height.px': 20 }"
      (click)="appService.debugMode.set(!appService.debugMode())"
    />
  </div>
</div>
